var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"rounded-full ml-2 border-solid border-2 border-gray-300 px-3 py-1 bg-gray-100"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }